export const ADMIN_GET_ORDERS = 'ADMIN_GET_ORDERS'
export const ADMIN_GET_ORDER = 'ADMIN_GET_ORDER'
export const ADMIN_UPDATE_ORDER = 'ADMIN_UPDATE_ORDER'
export const ADMIN_DELETE_ORDER = 'ADMIN_DELETE_ORDER'
